import { Card, Page } from "@shopify/polaris";
import React from "react";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { useCallback } from "react";

import { useAppContext } from "../../context";
import { UPDATE_AMAZON_IDEA } from "../../graphql/mutations/amazon-idea";
import { GET_AMAZON_IDEA } from "../../graphql/queries/amazon-idea";
import { getParamByRole, handleError } from "../../helper";
import history from "../../history";
import SkeletonPagePolaris from "../shared/SkeletonPagePolaris";
import { useToastContext } from "../shared/ToastContext";
import AmazonIdeaForm from "./amazon-idea-form";
import useTimeout from "../../hooks/useTimeout";

export default function UpdateAmazonIdeaPage() {
    const { id } = useParams();

    const { currentUser } = useAppContext();
    const pathname = getParamByRole(currentUser);
    const { setNotify, toggleToast } = useToastContext();

    const { data, loading, error } = useQuery(GET_AMAZON_IDEA, {
        variables: {
            id,
        },
        fetchPolicy: "no-cache"
    });

    const [setDelay] = useTimeout();
    const [updateAmazonIdea, { loading: updateLoading }] = useMutation(
        UPDATE_AMAZON_IDEA,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Update amazon idea successfully",
                    err: false,
                });
                setDelay(() => {
                    history.push(`/${pathname}/amazon-ideas`);
                }, 1000);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(
        (input) => {
            if (!input) return;

            setNotify && setNotify({ msg: null, err: false });
            toggleToast && toggleToast(true);
            updateAmazonIdea({
                variables: {
                    input: { ...input, id },
                },
            });
        },
        [updateAmazonIdea, setNotify, toggleToast, id],
    );

    return (
        <Page
            title="Update Amazon Idea"
            fullWidth
            breadcrumbs={[
                { content: "Amazon Ideas", url: `/${pathname}/amazon-ideas` },
            ]}
        >
            <Card sectioned>
                {loading ? (
                    <SkeletonPagePolaris />
                ) : error ? (
                    <div>Error: {handleError(error?.toString())}</div>
                ) : (
                    <AmazonIdeaForm
                        value={data?.getAmazonIdea}
                        onSubmit={handleSubmit}
                        loading={updateLoading}
                    />
                )}
            </Card>
        </Page>
    );
}
